import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

type CommentDictionary = { [commentId: number]: Comment };

export type CommentState = {
  commentsById: CommentDictionary;
  commentsStateByJobApplicantId: StateDictionary;
  commentsStateByEmployeeId: StateDictionary;
};
type State = { comments: CommentState };

export const commentsByIdSelector = (state: State) => state.comments.commentsById;
export const commentsStateByJobApplicantIdSelector = (state: State) =>
  state.comments.commentsStateByJobApplicantId;

export const commentsStateByEmployeeIdSelector = (state: State) =>
  state.comments.commentsStateByEmployeeId;

export const commentsForIdSelector = createSelector(
  [
    commentsByIdSelector,
    (_state: State, id: number) => id,
    (_state: State, _id: number, variant: ContactType) => variant,
  ],
  (commentsById, id, variant) =>
    Object.values(commentsById).filter((comment) =>
      variant === 'applicant'
        ? comment.activity.jobApplicantId === id
        : comment.activity.employeeId === id,
    ),
);

export const commentsStateForJobApplicantIdSelector = createSelector(
  [
    commentsStateByJobApplicantIdSelector,
    (_state: State, jobApplicantId: number) => jobApplicantId,
  ],
  (commentsStateByJobApplicantId, jobApplicantId) => commentsStateByJobApplicantId[jobApplicantId],
);
export const commentsStateForEmployeeIdSelector = createSelector(
  [commentsStateByEmployeeIdSelector, (_state: State, employeeId: number) => employeeId],
  (commentsStateByEmployeeId, employeeId) => commentsStateByEmployeeId[employeeId],
);
